import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import type { ReactElement } from 'react';

import SessionGuard from '../../components/SessionGuard';
import AuthLayout from '../../components/layout/AuthLayout/AuthLayout';
import { SigninPageItem } from '../../components/pages/signin/SigninPageItem';

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
  revalidate: 60,
});

function SignInPage() {
  return <SigninPageItem />;
}

SignInPage.getLayout = (page: ReactElement) => (
  <AuthLayout
    guard={SessionGuard}
    meta={{
      title: '메타.로그인.제목',
      description: '메타.로그인.설명',
    }}
  >
    {page}
  </AuthLayout>
);

export default SignInPage;
